import { gql } from '@apollo/client';

import { EventDetailsFragment } from '../../../types/__generated__';
import { buildQuery } from '../../hooks';
import usePageQuery from '../../hooks/usePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment EventDetails on Page {
    id
    joinUrl
    relationships {
      events(first: 1) {
        totalCount
        nodes {
          id
          title
          startDate
          endDate
          visible
        }
      }
    }
  }
`);

export function useEvent() {
  const result = usePageQuery<EventDetailsFragment>(FRAGMENT);

  const joinUrl = result?.data?.joinUrl;
  const events = result?.data?.relationships?.events;
  const event =
    events && events.totalCount === 1 && events.nodes[0]?.visible
      ? events.nodes[0]
      : null;

  return { joinUrl, event };
}
